import {
  downloadDonationReceiptPdf,
  type DonationReceiptTemplateData,
} from "@project/lib/receipt-pdf";

export type ReceiptData = DonationReceiptTemplateData;

export { numberToWordsIndian } from "@project/lib/receipt-words";

export function generateReceiptPdf(d: ReceiptData) {
  downloadDonationReceiptPdf(d);
}
